//https://tanstack.com/query/latest/docs/framework/react/guides/important-defaults
export const STALE_TIME = 5 * 60 * 1000; // 5 minutes
export const CACHE_TIME = 60 * 60 * 1000; // 1 hour
